import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

// Režim online dotahování chybějících dat (viz doc/plans/to-fill-data-fetching.md, krok 5).
// Stav žije JEN v prohlížeči (localStorage), server o něm nic neví.
//
//   'off'  — nedotahuj nikdy (i když mám právo)   [stav 1]
//   'ask'  — zeptej se dialogem před dotažením     [stav 2]  ← VÝCHOZÍ
//   'auto' — dotahuj hned, neptej se               [stav 3]
//
// Výchozí je 'ask' — po přihlášení / prvním použití se klient zeptá. Volba se drží
// (persist) dokud ji uživatel nezmění nebo se neodhlásí (reset() z useAuthStore).
const DEFAULT_MODE = 'ask'
const ORDER = ['off', 'ask', 'auto']

export const useOnlineModeStore = create(
  persist(
    (set, get) => ({
      mode: DEFAULT_MODE,
      setMode: (mode) => set({ mode }),
      cycle: () => {
        const i = ORDER.indexOf(get().mode)
        set({ mode: ORDER[(i + 1) % ORDER.length] })
      },
      // Reset na výchozí — volá se z useAuthStore.setAuth (login) a .logout.
      reset: () => set({ mode: DEFAULT_MODE }),
    }),
    {
      name: 'online-mode',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
